<div class="portlet light">
  <div *ngIf="(order$|async)?.subscription.status !== 1 else isSubClose">
  <div *ngIf="!this.orderIsDeleted else isDeleted">
    <div class="portlet-body">
      <storever-order-add
        [isLoading]="isLoading"
        #childComponents
        [form]="form"
        [isEdit]="isEdit"
        [isExchange]="isExchange"
        [isAdd]="isAdd"
        [isInternalUser]="isInternalUser"
        [order]="order$|async"
        [addressSummaries]="addressSummaries$|async"
        [orderForm]="orderForm"
        (resetDhlMsg)="clearDhlMessage()"
      ></storever-order-add>
    </div>
    <storever-footer-form *ngIf="isInternalUser"
                          [disabledSaveBtn]="dhlValidation"
                          [extraInfo]="dhlResult"
                          [form]="form"
                          [order]="order$|async"
                          [isEdit]="isEdit"
                          [isExchange]="isExchange"
                          (saveOutput)="save($event, form)"
                          (resetOutput)="resetForm(form)"
                          (cancelOutput)="cancel()"
                          (resetOrder)="resetPopup()"
                          (cancelOrderOutput)="cancelOrderPopup()"
    ></storever-footer-form>
  </div>
  </div>
  <ng-template #isDeleted>
    <div class="is-deleted"> {{ this.orderIsDeleted }} </div>
  </ng-template>
  <ng-template #isSubClose>
    <div class="is-deleted">{{'ORDER_EXCHANGE_SUBSCRIPTION_CLOSED' |translate:locale.language}}   </div>
  </ng-template>
</div>

<storever-cancel-order #cancelOrder></storever-cancel-order>
<storever-reset-order-modal #resetOrder>

</storever-reset-order-modal>
